;(function( $ ) {
	'use strict';

	$.fn.hasScrollBar = function() {
		return this.get( 0 ).scrollHeight > this.height();
	};

	/**
	 * @returns {jrwSmoothHashScroll}
	 */
	function jrwSmoothHashScroll() {
		var $this     = this,
			$document = $( 'body, html' );

		$.extend( $this, {
			animationTime: 1000,

			/**
			 * The target might be an ID or a name.
			 *
			 * @param hash
			 * @returns {*|HTMLElement}
			 */
			findTarget: function( hash ) {
				var $target = $( hash );
				return $target.length ? $target : $( '[name=' + hash.slice( 1 ) + ']' );
			},

			scrollToHash: function( hash ) {
				var target    = $this.findTarget( hash ),
					checkedAt = 0;

				if ( target.length && target.is( ':visible' ) ) {
					$document
						.stop()
						.animate(
							{ scrollTop: Math.ceil( target.offset().top ) },
							{
								easing: 'linear',
								duration: $this.animationTime,
								step: function( now, tween ) {
									var total       = Math.abs( tween.start - tween.end ),
										done        = Math.abs( now - tween.start ),
										currentTime = Math.ceil( done * $this.animationTime / total ) || 0;

									// There's no animation to do so just stop.
									if ( total <= 1 ) {
										$( this ).stop();
										return;
									}

									// Check the position of our destination every 20%.
									// If there's a change to the destination this check won't happen again.
									if ( currentTime > checkedAt + ($this.animationTime * 0.2) ) {
										checkedAt = currentTime + ($this.animationTime * 0.2);

//										console.debug( 'Checking at ' + currentTime );
										if ( Math.ceil( target.offset().top ) !== tween.end ) {
											// The target has change position so we'll redo the animation.
											$( this )
												.stop()
												.animate( { scrollTop: Math.ceil( target.offset().top ) }, {
													duration: $this.animationTime - currentTime,
													easing: 'linear'
												} );
										}
									}
								},
								always: function() {
									checkedAt = 0;
//									location.hash = hash;
								}
							}
						);

					return true;
				}
				else {
					return false;
				}
			},

			anchorScroll: function() {
				// Same domain and path so this could just be a link to something on this page
				if ( location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' ) && location.hostname == this.hostname && location.search == this.search ) {
					return !$this.scrollToHash( this.hash );
				}
			},

			locationScroll: function() {
				$this.scrollToHash( location.hash );
			},

			start: function( animationTime ) {
				$this.animationTime = animationTime || 600;
				$( document ).on( 'click', 'a[href*="#"]:not([href="#"])', $this.anchorScroll );
//				$( window ).on( 'hashchange', $this.locationScroll );
			},

			stop: function() {
				$( document ).off( 'click', 'a[href*="#"]:not([href="#"])', $this.anchorScroll );
//				$( window ).off( 'hashchange', $this.locationScroll );
			}

		} );

	}

	window.jrwSmoothHashScroll = new jrwSmoothHashScroll();

	$( document ).ready( function() {
//		window.jrwSmoothHashScroll.start();
	} );
}( jQuery ));
